import { Box, Typography } from '@mui/material'
import Big from 'big.js'
import { t } from 'i18next'
import { FC } from 'react'

import { Currency } from '@app/generated/graphql'
import { formatCurrency } from '@app/util'

type Props = {
  expenses: number
  currency: Currency
}

export const TrainerExpenses: FC<Props> = ({ expenses, currency }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb={1}>
      <Typography color="grey.700">
        {t('pages.book-course.trainer-expenses')}
      </Typography>
      <Typography color="grey.700">
        {formatCurrency(
          {
            amount: new Big(expenses).round(2).toNumber(),
            currency: currency,
          },
          t,
        )}
      </Typography>
    </Box>
  )
}
